import { render } from "./extra_notifications.vue?vue&type=template&id=1da7f708"
import script from "./extra_notifications.js?vue&type=script&lang=js"
export * from "./extra_notifications.js?vue&type=script&lang=js"

import "./extra_notifications.vue?vue&type=style&index=0&id=1da7f708&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__